export default class Device {
  constructor(title, category, userId, resellerId, modelId, serverId, sim, imei, disabled, expireTime, creationTime, modificationTime, plan) {
    this.title = title
    this.category = category
    this.userId = userId
    this.resellerId = resellerId
    this.modelId = modelId
    this.serverId = serverId
    this.sim = sim
    this.imei = imei
    this.disabled = disabled
    this.expireTime = expireTime
    this.creationTime = creationTime
    this.modificationTime = modificationTime
    this.plan = plan
  }
}
